import { html, LitElement } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { rmaRequest } from './rma-request.style.js'
import 'components/ordering/rma/components/latest-orders/latest-orders.js'
import 'components/ordering/rma/components/search/search.js'
import 'components/ordering/rma/components/sticky-bar/sticky-bar.js'
import 'components/ordering/rma/components/overview-slide-in/overview-slide-in.js'
import 'components/ordering/rma/components/discard-modal/discard-modal.js'
import 'components/ordering/rma/components/submit-modal/submit-modal.js'
import { type CSCRmaOverviewSlideIn } from 'components/ordering/rma/components/overview-slide-in/overview-slide-in.js'
import { type CSCRmaSubmitModal } from 'components/ordering/rma/components/submit-modal/submit-modal.js'
import { type CSCRmaDiscardModal } from 'components/ordering/rma/components/discard-modal/discard-modal.js'

@customElement('csc-rma-request')
export class CSCRmaRequest extends LitElement {
  static override styles = [hostStyle, rmaRequest]

  @property({ attribute: 'discard-url', type: String })
  public discardUrl = ''

  @property({ attribute: 'list-url', type: String })
  public listUrl = ''

  @query('csc-rma-overview-slide-in')
  private slideIn!: CSCRmaOverviewSlideIn

  @query('csc-rma-submit-modal')
  private submitModal!: CSCRmaSubmitModal

  @query('csc-rma-discard-modal')
  private discardModal!: CSCRmaDiscardModal

  private openOverview() {
    this.slideIn?.open()
  }

  private openSubmit() {
    this.submitModal?.open()
  }

  private openDiscard() {
    this.discardModal?.open()
  }

  override render() {
    return html`
      <div
        @csc-rma-overview-requested=${() => this.openOverview()}
        @csc-rma-submit-requested=${() => this.openSubmit()}
        @csc-rma-discard-requested=${() => this.openDiscard()}>
        <csc-rma-latest-orders class="rma-request__section"></csc-rma-latest-orders>
        <csc-rma-search class="rma-request__section"></csc-rma-search>
        <csc-rma-sticky-bar></csc-rma-sticky-bar>
        <csc-rma-overview-slide-in></csc-rma-overview-slide-in>
        <csc-rma-discard-modal discard-url=${this.discardUrl}></csc-rma-discard-modal>
        <csc-rma-submit-modal list-url=${this.listUrl}></csc-rma-submit-modal>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-rma-request': CSCRmaRequest
  }
}
